export function applications({offset = 0, limit = 4, count = false, type = ''}) {
    return axios.get(route('api.manage.companies.dashboard.applications'),
        {params: {offset, limit, count, type}})
        .then(response => response.data);
}

export function summary()
{
    return axios.get(route('api.manage.companies.dashboard.summary'))
        .then(response => response.data);
}
